enum AccessReportMaintJobStatusEnum {
  Unknown = "Unknown",
  NotCopied = "Not Copied",
  Queued = "Queued",
  Running = "Running",
  Cancelled = "Cancelled",
  InequalRowCount = "Inequal Row Count",
  Failed = "Failed",
  Copied = "Copied",
  Archived = "Archived",
}

export { AccessReportMaintJobStatusEnum };
